import {useMutation} from 'react-query';
import DeleteStory from '.';

const useDeleteStory = () => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (guid: string) => DeleteStory(guid),
  });

  return {mutate, isLoading, isSuccess};
};

export default useDeleteStory;
